import Cono from "./../img/NuestroShop/cono.png"
import IconoUno from './../img/NuestroShop/icono-1.png'
import IconoDos from './../img/NuestroShop/icono-2.png'
import IconoTres from './../img/NuestroShop/icono-3.png'

import './../css/components/NuestroShop.css'
function NuestroShop(){

    let shops = [
        {
            icono: IconoUno,
            numero: 1,
            paso:"Selecciona tus sabores",
            proceso:"El secreto es arriesgarse a combinar"
        },
        {
            icono: IconoDos,
            numero: 2,
            paso:"Agrega Toppings",
            proceso:"Salsas, frutas, tal vez rocklets o gomitas?"
        },
        {
            icono: IconoTres,
            numero: 3,
            paso:"Disfrútalo!",
            proceso:"Siente la variedad de sabores en el paladar!"
        }
    ]   

    return(
        <section className="shop">
            <div className="shop__titulo">
                <img src={Cono} className="shop__titulo__icono" />
                <h2>
                    -Nuestro shop-
                </h2>
                <p>
                    PRUÉBALO AHORA
                </p>          
            </div>
            <div className="shop__tarjetas">
                {
                    shops.map((sho)=>
                        <div className="shop__tarjetas__tarjeta">
                            <img src={sho.icono} />
                            <h1>
                                0{sho.numero}
                            </h1>
                            <h3>
                                {sho.paso}
                            </h3>
                            <p>
                                {sho.proceso}
                            </p>
                        </div>                    
                    )
                }

            </div>
        </section>
    )
}

export default NuestroShop;